import { config } from "@medbillai/ui";

export type Conf = { [K in keyof typeof config]: (typeof config)[K] };

declare module "tamagui" {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface TamaguiCustomConfig extends Conf {}
}

export default config;
